// Option lists shared across Add/Edit Owner forms.

export const GENDER_OPTIONS = [
    { value: 'MALE', label: 'Male' },
    { value: 'FEMALE', label: 'Female' },
    { value: 'OTHER', label: 'Other' },
];

export const ENTITY_TYPE_OPTIONS = [
    { value: 'I', label: 'Individual' },
    { value: 'C', label: 'Company' },
];

// GSTIN: 2-digit state code + 10-char PAN + 3 letters/digits (entity no., 'Z',
// check char - left open so special-category GSTINs pass). Same rule as the API.
const GSTIN_RE = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][0-9A-Z]{3}$/;

/** Error message for a GST number, or '' when it is empty or valid. */
export const gstinError = (gstin, pan) => {
    const gst = (gstin || '').trim().toUpperCase();
    if (!gst) return '';
    if (gst.length !== 15) return 'GST number must be exactly 15 characters';
    if (!GSTIN_RE.test(gst)) return 'Invalid GST number (e.g., 27ABCDE1234F1Z5)';
    const p = (pan || '').trim().toUpperCase();
    if (p && gst.slice(2, 12) !== p) return 'GST number does not match the PAN entered';
    return '';
};
